<match-display-wrapper
    matchLabel="{{ l10nKeys.clientTypeLabel | vtranslate }}"
    matchCriteria="{{ matchCriteria }}"
>
    <div *ngFor="let clientText of clientTexts; trackBy: trackByIndex">
        {{ clientText }}
    </div>
</match-display-wrapper>
